import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNavbar from "../components/BottomNavbar";
import { logout, resetPassword } from "../services/authService";

function Akun() {
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      alert("Kata sandi tidak cocok!");
      return;
    }

    const userId = localStorage.getItem("user_id");
    if (!userId) {
      alert("ID pengguna tidak ditemukan.");
      return;
    }

    const result = await resetPassword(userId, newPassword, confirmPassword);

    alert(result.message);

    if (result.success) {
      // Hapus data lokal dan redirect ke login
      localStorage.clear();
      navigate("/login");
    }
  };

  return (
    <div
      className="container py-4"
      style={{ paddingBottom: "80px", minHeight: "100vh" }}
    >
      <h4 className="fw-bold mb-4 text-center">Akun</h4>

      {/* Input Kata Sandi Baru */}
      <div className="mb-3">
        <label htmlFor="newPassword" className="form-label">
          Kata Sandi Baru
        </label>
        <div className="input-group">
          <input
            type={showNewPassword ? "text" : "password"}
            className="form-control rounded-3"
            id="newPassword"
            placeholder="Masukkan kata sandi baru"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => setShowNewPassword(!showNewPassword)}
          >
            <i
              className={`bi ${showNewPassword ? "bi-eye" : "bi-eye-slash"}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Input Konfirmasi Kata Sandi */}
      <div className="mb-4">
        <label htmlFor="confirmPassword" className="form-label">
          Konfirmasi Kata Sandi
        </label>
        <div className="input-group">
          <input
            type={showConfirmPassword ? "text" : "password"}
            className="form-control rounded-3"
            id="confirmPassword"
            placeholder="Ulangi kata sandi"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            <i
              className={`bi ${
                showConfirmPassword ? "bi-eye" : "bi-eye-slash"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {/* Tombol Reset */}
      <div className="d-grid mb-5">
        <button
          className="btn btn-primary rounded-pill fw-bold"
          onClick={handleResetPassword}
        >
          Reset Kata Sandi
        </button>
      </div>

      <hr />

      {/* Tombol Logout */}
      <div className="d-grid mb-4">
        <button
          className="btn btn-danger rounded-pill fw-bold"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>

      <BottomNavbar />
    </div>
  );
}

export default Akun;
